import { useLayoutEffect, useRef, useState } from 'react'
import { BLUR_HASH_MAP } from '@constants/BlurHashItems'
import BlurHashImage from '@components/BlurHashImage'
import { imageLoadCache } from '@utils/image-load-cache'
import '../GalleryPage.css'

function Image({ src, alt, onClick }) {
  const imgRef = useRef(null)
  const [loaded, setLoaded] = useState(() => imageLoadCache.has(src))

  // Catch browser-cache hits (img.complete=true) before the browser's first paint
  // so the dark container background never flashes through
  useLayoutEffect(() => {
    if (!loaded && imgRef.current?.complete) {
      imageLoadCache.add(src)
      setLoaded(true)
    }
  }, [src]) // intentionally omits `loaded` — only needs to run when src changes

  return (
    <div
      className={`gallery-image${loaded ? ' gallery-image--loaded' : ''}`}
      onClick={onClick}
    >
      <BlurHashImage hash={BLUR_HASH_MAP.gallery} fadeOut={loaded} />
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className="gallery-image__thumb"
        loading="lazy"
        onLoad={() => { imageLoadCache.add(src); setLoaded(true) }}
      />
      <div className="gallery-image__overlay"></div>
    </div>
  )
}

export default Image
